import { observable, action } from "mobx";
import axios from "axios";
import { IFile } from "../types";
import { message } from "../../../../pageComponents/ListItemComment/styles.scss";

const translator: any = (window as any).$.translator,
  locales: any = {
    filestypes: {
      all: translator.translate("Все файлы"),
    },
  };

interface IVideo {
  status: "ok" | "error" | string;
  message?: string;
  src?: string;
  poster?: string;
}

export default class FSViewerStore {
  rootStore: any;
  constructor(RootStore: any) {
    this.rootStore = RootStore;
    this.isLoading = false;
    this.isVisible = false;
    this.currentVideo = { status: undefined };
  }

  @observable isVisible: boolean;
  @observable currentId: number;
  @observable files: Array<IFile>;
  @observable currentFile: IFile;
  @observable isCurrentFileChecked: boolean;
  @observable currentVideo: IVideo;
  @observable isLoading: boolean;
  @action
  setLoading = (switcher = true) => {
    this.isLoading = switcher;
  };

  @action
  prepareVideo = () => {
    this.currentVideo = { status: undefined };
    if (this.currentFile.category === "video") {
      axios
        .get(`${this.currentFile.embedUrl}`, {
          headers: { "X-Requested-With": "XMLHttpRequest" },
        })
        .then((response) => {
          const data = response.data;
          if (data) {
            if (data.status === "ok") {
              this.currentVideo = {
                status: "ok",
                src: data.src,
                poster: data.poster
              };
              const videoElement = document.querySelector(".viewerVideo video");
              (window as any).AT.initPlayer(videoElement, {autoplay: true});
            } else if (data.message) {
              this.currentVideo.message = message;
            }
          } else {
            this.currentVideo = { status: undefined };
          }
        });
    }
  };

  @action
  showViewer = (fileId: number, files: Array<IFile>) => {
    this.files = files;
    this.currentId = files.findIndex((file: IFile) => file.id === fileId);
    this.currentFile = this.files[this.currentId];
    this.isVisible = true;
    this.isCurrentFileChecked = this.rootStore.fsStore.isFileChecked(
      this.currentFile
    );
    document.querySelector("body").classList.add("viewerIsOpen");
    this.prepareVideo();
  };

  @action
  hideViewer = () => {
    this.isVisible = false;
    document.querySelector("body").classList.remove("viewerIsOpen");
  };

  @action
  showFile = (currentId: number) => {
    this.currentFile = this.files[currentId];
    this.isCurrentFileChecked = this.rootStore.fsStore.isFileChecked(
      this.currentFile
    );
    this.prepareVideo();
    return this.currentFile;
  };

  @action
  currentFileCheckToggle = () => {
    if (
      !document.querySelectorAll(
        `#filestorage-fileCheck-${this.currentFile.id}`
      ).length
    ) {
      this.rootStore.fsStore.onFileCheck(this.currentFile);
    }
    this.isCurrentFileChecked = !this.isCurrentFileChecked;
  };
}

export { FSViewerStore };
